




import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const EditEventForm = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [venue, setVenue] = useState("");
  const [price, setPrice] = useState("");
  const [totalTickets, setTotalTickets] = useState("");
  const [description, setDescription] = useState("");
  const [datetime, setDatetime] = useState("");
  const [mediaFile, setMediaFile] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchEventDetails = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`https://localhost:7136/api/event/${eventId}`, {});
        const eventData = response.data;
        if (eventData) {
          setTitle(eventData.title);
          setVenue(eventData.venue);
          setPrice(eventData.ticketPrice);
          setTotalTickets(eventData.totalTickets);
          setDescription(eventData.description);
          setDatetime(new Date(eventData.eventDatetime).toISOString().slice(0, 16));
          setMediaFile(eventData.mediaFile); // حاول تجيب ال mediaFile URL
        } else {
          setErrorMsg("لم يتم العثور على الفعالية.");
          setLoading(false);
          return;
        }
      } catch (error) {
        setErrorMsg("حدث خطأ أثناء تحميل بيانات الفعالية.");
        console.error("Error fetching event data:", error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    if (eventId) {
      fetchEventDetails();
    }
  }, [eventId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    if (!token) {
      setErrorMsg("برجاء تسجيل الدخول أولاً.");
      return;
    }

    const formData = new FormData();
    formData.append("Title", title);
    formData.append("Venue", venue);
    formData.append("TicketPrice", price);
    formData.append("TotalTickets", totalTickets);
    formData.append("Description", description);
    formData.append("EventDatetime", datetime);
    if (mediaFile) {
      formData.append("MediaFile", mediaFile);
    }

    try {
      const response = await axios.put(`https://localhost:7136/api/event/${eventId}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 204) {
        setSuccessMsg("تم تحديث الفعالية بنجاح!");
        setErrorMsg("");
        alert("تم تحديث الفاعلية بنجاح وارسال الاشعارات للمستخدمين ");

        navigate("/organizer");
      } else {
        setErrorMsg("حدث خطأ أثناء تحديث الفعالية.");
        setSuccessMsg("");
      }
    } catch (error) {
      console.error("Error updating event:", error);
      setErrorMsg(error.response?.data?.message || "An unexpected error occurred");
      setSuccessMsg("");
    }
  };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setMediaFile(e.target.files[0]);
        }
    };


  if (errorMsg) {
    return (
      <div
        className="min-h-screen bg-cover bg-center p-8"
        style={{ backgroundImage: `url('./images/photo20.jpg')` }}
      >
        <div className="max-w-2xl mx-auto bg-white bg-opacity-80 backdrop-blur-md p-6 rounded-xl shadow-xl">
          <h2 className="text-3xl font-bold text-purple-800 mb-6 text-center">
            تعديل الفعالية
          </h2>
          <p className="text-red-600 text-center mb-4">{errorMsg}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen bg-cover bg-center p-8"
      style={{ backgroundImage: `url('./images/photo20.jpg')` }}
    >
      <div className="max-w-2xl mx-auto bg-white bg-opacity-80 backdrop-blur-md p-6 rounded-xl shadow-xl">
        <h2 className="text-3xl font-bold text-purple-800 mb-6 text-center">
          تعديل الفعالية
        </h2>
        {successMsg && (
          <p className="text-green-600 text-center mb-4">{successMsg}</p>
        )}
        {errorMsg && <p className="text-red-600 text-center mb-4">{errorMsg}</p>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="اسم الفعالية"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full p-3 border rounded-xl"
            required
          />
          <input
            type="text"
            placeholder="المكان"
            value={venue}
            onChange={(e) => setVenue(e.target.value)}
            className="w-full p-3 border rounded-xl"
            required
          />
          <input
            type="number"
            placeholder="السعر"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className="w-full p-3 border rounded-xl"
            required
            min="0"
          />
          <input
            type="number"
            placeholder="عدد التذاكر"
            value={totalTickets}
            onChange={(e) => setTotalTickets(e.target.value)}
            className="w-full p-3 border rounded-xl"
            required
            min="0"
          />
          <input
            type="datetime-local"
            value={datetime}
            onChange={(e) => setDatetime(e.target.value)}
            className="w-full p-3 border rounded-xl"
            required
          />
          <textarea
            placeholder="الوصف"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full p-3 border rounded-xl"
            rows={4}
            required
          />
          <input
            type="file"
            onChange={handleFileChange}
            className="w-full p-2 rounded-xl"
            accept="image/*,video/*"
          />
          <button
            type="submit"
            className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-xl transition"
          >
            تحديث الفعالية
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditEventForm;








